/**
 * Two analytics events, and only two: a tool RUN and a SHARE.
 *
 * GA4 was configured with page views alone, so a site of tools could count visitors and never tell
 * a visitor who used a tool from one who read the landing and left — the one number its ad model
 * depends on. The tool's name comes from `<meta name="arcate-tool">`, posed by the head whenever a
 * page is about one; a form that is not a tool form (search, comments) emits nothing.
 *
 * This script does not decide on consent: `gtag` exists only once the measurement has started (the
 * visitor accepted it, or the ad consent message drives it), and Consent Mode handles the rest.
 * No `gtag` on the page (no analytics, or no consent) = nothing at all.
 */
function toolKey() {
	const meta = document.querySelector('meta[name="arcate-tool"]');
	return meta ? meta.content : null;
}

function send(name, parameters) {
	if (typeof window.gtag === 'function') {
		window.gtag('event', name, parameters);
	}
}

document.addEventListener('submit', (event) => {
	const form = event.target;
	if (!(form instanceof HTMLFormElement) || !form.closest('.arcate-tool-form, .arcate-tool-landing-form')) {
		return;
	}
	const tool = toolKey();
	if (tool) {
		send('tool_run', { tool });
	}
});

document.addEventListener('click', (event) => {
	const link = event.target.closest('.variant-share a[href]');
	if (!link) {
		return;
	}
	const network = (link.textContent || '').trim().toLowerCase() || 'unknown';
	send('share', { method: network, content_type: toolKey() ? 'tool' : 'page', item_id: location.pathname });
});
